import { useSearchParams } from 'react-router';
import { decodeFolderPath } from '@/lib/utils';

/**
 * Read and decode the `path` search param from the URL.
 * Handles scio1 tilde-encoding (`~2F` → `/`). Idempotent — safe on already-decoded paths.
 *
 * @returns decoded path string, or `null` if no `path` param is present.
 */
export function useDecodedPath(): string | null {
  const [searchParams] = useSearchParams();
  const raw = searchParams.get('path');
  return raw ? decodeFolderPath(raw).trim() : null;
}
